import { Button } from "@similarweb/ui-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { ProfileModalState } from "../../types/state";
import type { Profile } from "../../types/common";
import { StyledHeader, StyledFooter, StyledBody, StyledModalInner, CUSTOM_MODAL_STYLES } from "./styles";

export type RemoveProfileModalProps = Omit<ProfileModalState, "profile"> & {
    profile: Pick<Profile, "id"> | null;
    isLoading: boolean;
    onCancel(): void;
    onSubmit(id: Profile["id"]): void;
};

const RemoveProfileModal = (props: RemoveProfileModalProps) => {
    const { isOpened, isLoading, profile, onCancel, onSubmit } = props;

    return (
        <ProModal
            isOpen={isOpened}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={CUSTOM_MODAL_STYLES}
        >
            <StyledModalInner>
                <I18n
                    element={StyledHeader}
                    translatable={{ key: "si.contacts-search-profiles.modal.delete.title" }}
                />
                <StyledBody />
                <StyledFooter>
                    <Button
                        type="flatDark"
                        onClick={onCancel}
                        dataAutomation="profile-modal-button-cancel"
                    >
                        {translate("si.common.button.cancel")}
                    </Button>
                    <Button
                        type="warning"
                        isLoading={isLoading}
                        isDisabled={isLoading}
                        onClick={() => onSubmit(profile.id)}
                        dataAutomation="profile-modal-button-cancel"
                    >
                        {translate("si.common.button.delete")}
                    </Button>
                </StyledFooter>
            </StyledModalInner>
        </ProModal>
    );
};

export default RemoveProfileModal;
